<template>
  <div
    class="space-y-1 text-xs font-semibold pb-2 pt-2 px-4"
  >
    <transition name="sf-fade">
      <div
        v-if="show"
        :data-testid="testId"
        class="text-EXPONDO-red"
      >
        <slot name="error">{{ message }}</slot>
      </div>
    </transition>
    <slot />
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'InputErrorMessage',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    hasMessages: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
    testId: {
      type: String,
      default: undefined,
    },
  },
});

</script>
